export const reviewsData = {
  russian: [
    {
      id: 1,
      image: "/assets/images/reviewer3.jpg",
      text: "Для меня йога с тобой стала классным способом не только поддерживать себя физически в лучшем состоянии, но и ментально очень отдыхала на практиках, спасибо тебе ✨",
      name: "Катя",
    },
    {
      id: 9,
      image: "/assets/images/reviewer3.jpg",
      text: "Вообще удивительно насколько сильный прогресс случился с начала занятий. Всего месяца за 2-3? Я даже и представить не мог, что смогу делать такие штуки, стану настолько выносливее и визуально поменяюсь за такой короткий срок. Аня, спасибо большое! Все только благодаря тебе и твоим тренировкам.",
      name: "Дима",
    },
    {
      id: 3,
      image: "/assets/images/reviewer1.jpg",
      text: "Мне очень нравились твои уроки по энергетике, с тобой приятно находиться в одном пространстве. То как ты даешь йогу, мне очень подходит. Может быть кому-то хочется послабее или посильнее, мне вот это в самый раз. Я люблю, чтобы не зависали люди в асанах, чтобы все было в достаточно хорошем темпе и нагрузка для меня кажется оптимальной. То есть это и challenging и по силам мне. Мне нравится, когда преподаватель обращает внимание, чуть подкорректирует, но не слишком сильно, чтобы я не чувствовала сверх критики в свой адрес, но и мягкая коррекция тоже необходима. Для меня было супер классно, что ты мне помогаешь запрышивать в стойку на руках, потому что хочется постоять, запрыгнуть, почувствовать, что я что-то могу.",
      name: "Екатерина",
    },
    {
      id: 8,
      image: "/assets/images/reviewer3.jpg",
      text: "Огромное спасибо Ане Joy за её вдохновляющие занятия! Это не просто уроки йоги, а настоящее путешествие к гармонии тела и духа. Каждое занятие проводится с вниманием к деталям, заботой о каждом участнике и с удивительной теплой и располагающей энергетикой. Анюта умеет создать уютную и безопасную атмосферу, где хочется раскрывать свои возможности и становиться лучше. Она всегда предлагает варианты для любого уровня подготовки, что позволяет каждому почувствовать уверенность в своих силах. После её практик я чувствую лёгкость, спокойствие и заряд энергии. Это бесценный опыт, который я с радостью рекомендую всем!",
      name: "Даша",
    },
    {
      id: 7,
      image: "",
      text: "Anya Joy обалденный преподаватель! Хожу только первый месяц, но вижу результаты. Как тело меняется на глазах, и подтягивает за собой мышление. Распаковываются давно забытые вещи, откуда-то появляется энергия продолжать начинания, которые казались фантазиями еще пару месяцев назад! Короче, не рекомендую тем, кто не хочет совершать прорыв в своей жизни 😜🥳🤩",
      name: "Анна",
    },
    {
      id: 4,
      image: "/assets/images/reviewer2.jpg",
      text: "Благодорю за вчерашнюю практику🙏 Хорошо попрактиковали,ушла от вас наполненная энергией и в то же время с тишиной в уме. Тот случай,когда все сложилось-атомосфера,люди,настрой и классный преподователь.☘️",
      name: "Анжела",
    },
    {
      id: 2,
      image: "/assets/images/reviewer3.jpg",
      text: "Как человек, занимающийся йогой более 2 лет и побывавший на практиках у нескольких разных инструкторов, могу однозначно рекомендовать инструктора Аню Джой. Практика с Аней всегда оставляет позитивное впечатление и дает заряд энергии, а также ощущение повышенного тонуса в теле в течение следующих 48 часов. Аня внимательна к ученикам, замечает и корректирует неправильное выполнение асан и техник. Динамика занятий имеет среднюю интенсивность, что делает их подходящими как для новичков, так и для более опытных практикующих",
      name: "Артём",
    },
    {
      id: 5,
      image: "/assets/images/reviewer3.jpg",
      text: "Спасибо за сегодня! Я очень Рада что тебя нашла ))) было кайфово ! Не просто но кайфово !!!",
      name: "Варвара",
    },
    {
      id: 6,
      image: "/assets/images/reviewer3.jpg",
      text: "Мне выпал случай побывать у Ани на уроках Йоги. Всегда очень комфортно на ее уроках, ее спокойствие и уверенность передается всем участникам, поэтому всегда присутствует комфортная, спокойная энергетика на занятиях. Если вам это важно, то несомненно у Ани вам понравится! Так же мне понравилось плавное вхождение в более тяжелые позы и плавный с них выход, что делает окончание занятий очень естественным и приятным.",
      name: "Аня",
    },
  ],
  english: [],
};
